export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		SELLER: 3,
		AFFILIATE: 4,
		USER: 5,
	},
	AFFILIATE_TYPES: {
		MEDIC: 1,
		CLINIC: 2,
		BUSINESS_SERVICE_OR_ADVERTISER: 3,
	},
	PAYMENT_METHODS: {
	    ZELLE: 1,
	    MOVIL: 2,
	    CASH: 3,
	},
	CURRENCIES: {
		VES: 1,
		USD: 2,
	},
	BANNERS: {
	    PRINCIPAL: 1
	},
	BANK_ACCOUNT_TYPES: {
	    NATIONAL: 1,
	    INTERNATIONAL: 2
	},
	BANK_ACCOUNT_STATUS: {
	    ACTIVE: 1,
	    INACTIVE: 0
	},
	MODULES: {
		REGISTER: 1,
        MODERATORS: 2,
        QUOTES: 3,
      	PLANS: 4,
        BANK_ACCOUNTS: 5,
        BANNERS: 6,
        SERVICES: 7,
        SPECIALITIES: 8,
      	COMMISSIONS: 9,
	},
	USER_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	USER: {
		STATUS: {
			ACTIVE: 1,
			INACTIVE: 0
		},
		VERIFICATION: {
			PENDING: 0,
			APPROVED: 1,		
			REJECTED: 2
		},
		AREAS_SPECIALIZATION: {
			PEQ_ANIMALES: { id: 1, name: 'Pequeños animales' },
			GRA_ANIMALES: { id: 2, name: 'Grandes animales' },
			EXOTICOS: { id: 3, name: 'Exóticos' },
		},
		SERVICES: {
			DIAGNOSTICO: { id: 1, name: 'Diagnóstico' },
			TRATAMIENTOS: { id: 2, name: 'Tratamientos' },
			VACUNACION: { id: 3, name: 'Vacunación' },
			DESPARASITACION: { id: 4, name: 'Desparasitación' },
			ATENCION_DENTAL: { id: 5, name: 'Atención dental' },
			ASESORIA_NUTRICIONAL: { id: 6, name: 'Asesoría nutricional' },
			OTROS: { id: 7, name: 'Otros' },
		},
	},
	GENDERS: {
		MALE: 1,
		FEMALE: 2
	},
	PLAN_PAYMENT_STATUS: {
		PENDING: 0,
		ACCEPTED: 1,
		REJECTED: 2
	},
	QUOTE_RESPONSE_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	QUOTE_RESPONSE_VIEWED: {
		VIEWED: 1,
		NOT_VIEWED: 0
	},
	SERVICE_TYPES: {
		EXAM: 1,
		SURGERIES: 2
	},
	ANIMAL: {
		TYPE: {
			PET: 1,
			FARM: 2,
		}
	},
	ADVERTISEMENTS: {
		TYPE: {
			CLASSIFIED: 1,
			BANNERS: 2,
		}
	},
	FREQUENCY: {
		MONTHLY: 1, //Mensual
		QUARTERLY: 2, //trimestral
		SEMESTER: 3, //Semestral
		ANNUAL: 4     //Anual 
	},
	COMMISSIONS: {
		STATUS:{
			PENDING: 0,
			PAID: 1,
		},
	},
	AFFILIATE_ANIMALS: {
		/*
		1: Perros, 2: Gatos, 3: Aves, 4: Mamiferos pequeños, 5: Mamiferos grandes, 6: Peces, 7: Otros
		*/
		PERROS: { id: 1, name: 'Perros' },
		GATOS: { id: 2, name: 'Gatos' },
		AVES: { id: 3, name: 'Aves' },
		MAMIFEROS_PEQ: { id: 4, name: 'Mamiferos pequeños' },
		MAMIFEROS_GRA: { id: 5, name: 'Mamiferos grandes' },
		PECES: { id: 6, name: 'Peces' },
		OTROS: { id: 7, name: 'Otros' },
	},
	SPECIALTIES: {
		MEDICINA_INTERNA: { name: 'Medicina interna' },
		OFTALMOLOGIA: { name: 'Oftalmología' },
		CARDIOLOGIA: { name: 'Cardiología' },
		TRAUMATOLOGIA: { name: 'Traumatología' },
		OTROS: { name: 'Otros '},
	},
	AREAS_SPECIALIZATION: {
		PEQ_ANIMALES: { id: 1, name: 'Pequeños animales' },
		GRA_ANIMALES: { id: 2, name: 'Grandes animales' },
		EXOTICOS: { id: 3, name: 'Exóticos' },
	},
	SERVICES: {
		DIAGNOSTICO: { id: 1, name: 'Diagnóstico' },
		TRATAMIENTOS: { id: 2, name: 'Tratamientos' },
		VACUNACION: { id: 3, name: 'Vacunación' },
		DESPARASITACION: { id: 4, name: 'Desparasitación' },
		ATENCION_DENTAL: { id: 5, name: 'Atención dental' },
		ASESORIA_NUTRICIONAL: { id: 6, name: 'Asesoría nutricional' },
		OTROS: { id: 7, name: 'Otros' },
	},
}